import TextInput from "components/common/custom/forms/BootTextField/TextField";
import { Col, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import MultiSelect from "components/common/MultiSelect";
const VitalSignCard = ({
  watch,
  setValue,
  control,
  name,
  label,
  subLabel,
  min,
  imageSrc,
  dropdown,
  background,
  required,
  max,
}) => {
  return (
    <Row className="sign-vital">
      <Col xs={9}>
        <div className="d-flex flex-column w-100">
          <div className="d-flex align-items-end justify-content-between w-100">
            <h5 className="fs-11 mb-0" style={{ flex: 1 }}>
              {label}
            </h5>

            <span className="fs-12">{subLabel}</span>
          </div>

          {!dropdown && (
            <>
              <TextInput
                name={`${name}`}
                control={control}
                required={required}
                size="sm"
                type="number"
                min={min}
                max={max}
                style={{ flex: 1, marginTop: "8px" }}
              />
              <div className="d-flex align-items-center  gap-1 mt-2">
                <h6 className="text-muted fs-11">{min}</h6>
                <Form.Range
                  min={min}
                  max={max}
                  value={watch(`${name}`) || min}
                  onChange={(e) => setValue(`${name}`, e.target.value)}
                />
                <h6 className="text-muted fs-11">{max}</h6>
              </div>
            </>
          )}
          {dropdown && (
            <Controller
              name="heart_rhythm"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="top"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  className="mt-2"
                  options={[
                    { heart_id: 1, heart_name: "Sins rhythm" },
                    { heart_id: 2, heart_name: "Atrial Fibrillation" },
                    { heart_id: 3, heart_name: "Atrial Flutter" },
                    { heart_id: 4, heart_name: "Second degree heart block" },
                  ].map((item) => ({
                    value: item.heart_id,
                    label: item.heart_name,
                  }))}
                  value={
                    field.value
                      ? {
                          value: field.value.heart_id,
                          label: field.value.heart_name,
                        }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "heart_rhythm",
                      selected
                        ? {
                            heart_id: selected.value,
                            heart_name: selected.label,
                          }
                        : null
                    );
                  }}
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          )}
        </div>
      </Col>
      <Col xs={3}>
        <div
          style={{
            borderRadius: "10px",
            padding: "8px",
          }}
          className={`d-flex align-items-center ${background} justify-content-center`}
        >
          <img src={imageSrc} style={{ width: "30px", height: "30px" }} />
        </div>
      </Col>
    </Row>
  );
};

export default VitalSignCard;
